// What he has typed for a session and not sent, kept in this browser so that
// a reload finds it, for the member who typed it. Without storage it lives
// as long as the page.
const KEY = 'poulpe.code.draft'

const keyOf = (member: string | null, session: string) => `${KEY}.${member ?? ''}.${session}`

export function readDraft(member: string | null, session: string): string {
  try {
    return window.localStorage.getItem(keyOf(member, session)) ?? ''
  } catch {
    return ''
  }
}

export function saveDraft(member: string | null, session: string, text: string): void {
  try {
    if (text === '') window.localStorage.removeItem(keyOf(member, session))
    else window.localStorage.setItem(keyOf(member, session), text)
  } catch {
    // Without storage the draft lives as long as the page.
  }
}
